import React from 'react'

import { Tab, TabsWrapper } from './styles'

export const Tabs = ({ activeTab, onChange }) => {
  return (
    <TabsWrapper>
      <Tab active={activeTab === 'avista'} onClick={() => onChange('avista')}>
        Pagar à vista
      </Tab>
      <Tab active={activeTab === 'parcelado'} onClick={() => onChange('parcelado')}>
        Pagar parcelado
      </Tab>
    </TabsWrapper>
  )
}
